<template>
    <div v-if="!loading && hasAccess" class="h-full">
        <top-nav-bar></top-nav-bar>

        <list v-if="newsletters.length > 0">
            <list-item class="text-base sm:text-xl"
                       v-for="newsletter in newsletters" :key="newsletter.id"
                       @click="processNotifications(newsletter)"
                       :url="documentUrl(newsletter.id)" target="_blank">
                <template slot="link-icon">
                    <span class="text-blue">
                        <icon icon="far fa-arrow-circle-right" classes="w-8 h-8"></icon>
                    </span>
                </template>
                <template slot="icon">
                    <i class="text-blue text-xl fal fa-newspaper"></i>
                </template>
                <template slot="title">
                    <span class="relative">
                        <div class="mr-4 word-break-word overflow-hidden">{{newsletter.title}}</div>
                        <span
                            class="h-4 flex absolute pin-t pin-r items-center justify-center bg-red rounded-full text-white text-xs px-1"
                            v-if="$hasNotification('newsletters', newsletter.id).length > 0"
                            v-text="$hasNotification('newsletters', newsletter.id).length"></span>
                    </span>
                </template>
                <template slot="sub-title">
                    <span class="text-xs">
                        Published {{formatDate(newsletter.created_at, 'MMMM Do YYYY')}}
                    </span>
                </template>
            </list-item>
        </list>
        <empty :visible="!newsletters.length">
            Currently there are no newsletters available.
        </empty>
    </div>
    <div v-else class="h-full flex items-center justify-center pt-8">
        <i class="text-blue fas fa-spinner fa-spin fa-3x"></i>
    </div>
</template>

<script>
    import InteractsWithDates from '@/mixins/InteractsWithDates';
    import auth from '../auth';
    import {mapState} from 'vuex';
    import CanAccessView from "../mixins/CanAccessView";

    export default {
        mixins: [InteractsWithDates, CanAccessView],

        data() {
            return {
                newsletters: [],
                loading: true,
                message: ''
            }
        },

        computed: {
            ...mapState(['employee']),

            employeeID() {
                if (this.employee !== null) {
                    return this.employee.id;
                }

                return '';
            }
        },

        mounted() {
            this.$store.dispatch('fetchEmployee');

            this.$api().get('newsletter')
                .then(({data}) => this.newsletters = data.data)
                .catch(({response}) => this.message = response.message)
                .finally(() => this.loading = false);
        },

        methods: {
            documentUrl(id) {
                return `${process.env.VUE_APP_PORTAL}/api/employee/newsletter/${id}?api_token=${auth.getToken()}&timestamp=${(new Date()).getTime()}&download`;
            },

            processNotifications(newsletter) {
                let notifications = this.$hasNotification('newsletters', newsletter.id);

                if (notifications.length > 0) {
                    notifications.forEach(notification => this.$notificationRead(notification));
                }
            }
        },
    }
</script>

<style scoped>

</style>
